import React from 'react';
import {Link} from 'react-router-dom';

const error404 = () => {
  return (
    <div id="error404" title="Solaria Indonesia" className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-purple-700 via-pink-800 to-red-500 px-4">
    <h1 className="text-white text-9xl font-extrabold tracking-widest">404</h1>
    <div className="bg-white px-6 py-4 rounded-md shadow-md mt-4 max-w-xs text-center">
      <h2 className="text-2xl font-semibold text-gray-800 mb-2">Page Not Found!</h2>
      <p className="text-gray-600 mb-4">Maaf, silahkan hubungi Pak Nurman atau Pak Soleh ya. Terima Kasih Bosskuu.</p>
        <Link
          to="/"
          className="inline-block px-5 py-2 rounded-md bg-pink-800 text-white font-semibold hover:bg-pink-500 transition"
        >
          Visit Solaria Indonesia
        </Link>
        <p className="mt-2 text-sm">
        <Link to="/admin" 
              className="font-semibold underline text-black hover:text-red-500">
            <span >Coba login lagi ?</span>
        </Link>
        </p>
      </div>  
    </div>
  );
};

export default error404